import { render } from "./Work2Header.vue?vue&type=template&id=43b2ed7c&scoped=true"
import script from "./Work2Header.vue?vue&type=script&lang=js"
export * from "./Work2Header.vue?vue&type=script&lang=js"

import "./Work2Header.vue?vue&type=style&index=0&id=43b2ed7c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43b2ed7c"]])

export default __exports__